import React from "react";
import cecoCareBanner from "./CecoCare-banner.jpg";
import "./CecoCareBanner.scss";

export default function CecoCareBanner() {
  return (
    <a
      className="ceco-care-banner"
      href="https://support.storececotec.com/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        className="ceco-care-banner__image"
        src={cecoCareBanner}
        alt="CecoCare"
      />
    </a>
  );
}
